export default "/images/vendor/flag-icon-css/flags/1x1/in.svg?a8b035d61b54fec572a00298f9a05aaa";